import { render, staticRenderFns } from "./DispatchPage.vue?vue&type=template&id=313ba4eb&scoped=true"
import script from "./DispatchPage.vue?vue&type=script&lang=js"
export * from "./DispatchPage.vue?vue&type=script&lang=js"
import style0 from "./DispatchPage.vue?vue&type=style&index=0&id=313ba4eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ba4eb",
  null
  
)

export default component.exports